// Share this query with the landing page's CSS visibility rules.
export const MOBILE_DEVICE_QUERY = "(pointer: coarse) and (hover: none)";

export function isMobileDevice(
  device: { userAgent: string; platform: string; maxTouchPoints: number } = navigator,
  coarsePointer = matchMedia(MOBILE_DEVICE_QUERY).matches,
): boolean {
  // iPadOS can identify itself as a Mac, including with a paired mouse.
  return (
    coarsePointer ||
    /Android|iPhone|iPad|iPod|Mobile/i.test(device.userAgent) ||
    (device.platform === "MacIntel" && device.maxTouchPoints > 1)
  );
}
